module.exports = __webpack_public_path__ + "static/media/port_icon.be09fa1a.png";